import React, { createContext, useContext, useState } from "react";
import "./Toast.scss";
import {Check, X} from "lucide-react"

const ToastContext = createContext();

const Toast = ({ message, type = "info", duration = 5000, onClose }) => {
    const [isVisible, setIsVisible] = useState(false);

    React.useEffect(() => {
        const showTimer = setTimeout(() => setIsVisible(true), 10);

        const hideTimer = setTimeout(() => {
            setIsVisible(false);
            setTimeout(onClose, 300);
        }, duration);

        return () => {
            clearTimeout(showTimer);
            clearTimeout(hideTimer);
        };
    }, [duration, onClose]);

    return (
        <div className={`toast-ui-wrapper`}>
            <div className={`toast-ui ${type} ${isVisible ? "toast-ui-animate-in" : ""}`}>
                <div className={`toast-ui-icon text-${type}`}>
                    {type === "success" && <Check style={{
                        color: "#198754"
                    }} />}
                    {type === "error" && <X style={{
                        color: "#dc3545"
                    }} />}
                    {type === "warning" && "⚠"}
                    {type === "info" && "i"}
                </div>
                <div className={`toast-ui-message ${"text-" + type}`}>{message}</div>

                {/* Replaced button → span (Bootstrap won't affect it) */}
                <span className="toast-ui-close" onClick={onClose}>✖</span>
            </div>
        </div>
    );
};

export const ToastProvider = ({ children }) => {
    const [toasts, setToasts] = useState([]);

    const addToast = (message, type = "info", duration = 5000) => {
        const newToast = { id: Date.now(), message, type, duration };
        setToasts(prev => [...prev, newToast]);
    };

    const removeToast = (id) => {
        setToasts(prev => prev.filter(t => t.id !== id));
    };

    const resetToast = () => setToasts([]);

    return (
        <ToastContext.Provider value={{ addToast, resetToast }}>
            {children}

            <div className="toast-container-ui">
                {toasts.map(toast => (
                    <Toast
                        key={toast.id}
                        {...toast}
                        onClose={() => removeToast(toast.id)}
                    />
                ))}
            </div>
        </ToastContext.Provider>
    );
};

export const useToast = () => useContext(ToastContext);
